import { render } from "./FormCard.vue?vue&type=template&id=7c25f8c0&scoped=true"
import script from "./FormCard.vue?vue&type=script&lang=js"
export * from "./FormCard.vue?vue&type=script&lang=js"

import "./FormCard.vue?vue&type=style&index=0&id=7c25f8c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c25f8c0"]])

export default __exports__